// LL052 advisory, deliberate: the guard's dialog reads the settlement store, so
// promoting it would invert the coupling rather than remove it.
import { createAccountingModeGuard, billClientChangeErrorMessage } from '@/modules/matters/accountingModeGuard';
angular.module('leanlaw').controller('MatterAccountingEditCtrl', ['$scope', '$q', '$stateParams', 'leanLawApi', '$state', 'accountingService', 'userService', 'alerts', function ($scope, $q, $stateParams, leanLawApi, $state, accountingService, userService, alerts) {
  $scope.message = $stateParams.message;
  $scope.loading = true;
  $scope.saving = false;
  $scope.data = {
    matter: {},
    clientCustomer: {
      selected: null,
      create: false,
      name: '',
      query: '',
      results: []
    },
    billClient: false,
    allowChange: true,
    pickClientBilling: false,
    matterCustomer: {
      selected: null,
      create: false,
      name: '',
      query: '',
      results: []
    }
  };

  // Type-ahead search (sc-46822) -- replaces the whole-firm preload that used to populate
  // data.customers. 'client' searches top-level QuickBooks customers; 'matter' scopes the
  // search to the currently selected client's sub-customers (parentId).
  const searchSequence = {
    client: 0,
    matter: 0
  };
  $scope.searchClient = function (level) {
    const target = level === 'matter' ? $scope.data.matterCustomer : $scope.data.clientCustomer;
    const parentId = level === 'matter' ? $scope.data.clientCustomer.selected && $scope.data.clientCustomer.selected.id : null;
    if (!target.query) {
      target.results = target.selected ? [target.selected] : [];
      return;
    }
    // Guard against a slower response for an earlier keystroke landing after a faster,
    // later one and overwriting target.results with stale matches.
    const sequence = ++searchSequence[level];
    accountingService.searchClients(target.query, parentId).then(results => {
      if (sequence !== searchSequence[level]) return;
      target.results = results;
    }).catch(err => {
      if (sequence !== searchSequence[level]) return;
      alerts.error(err);
    });
  };

  // sc-47290: second write path to the mode, so it shares the Billing tab's guard.
  const accountingModeGuard = createAccountingModeGuard();
  let destroyed = false; // a late resolution must not write through a dead $scope
  // Snapshot: separates a real mode change from a Save that only remaps customers.
  let loadedBillClient;
  $scope.$on('$destroy', () => {
    destroyed = true;
    accountingModeGuard.destroy();
  });
  $scope.changeBillClient = function () {
    $scope.data.pickClientBilling = true;
    // Effective mode, not the raw field: raw is undefined on the company default,
    // which reads back as a switch to Matter level nobody asked for. Behind the
    // same flipper as this tab's toggle (sc-46865) — same feature, same flag.
    $scope.data.billClient = clientAccountingEnabled() ? loadedBillClient : $scope.data.matter.client.billing.billClient;
  };
  $scope.cancel = function () {
    if (typeof $stateParams.onCancel === "function") {
      $stateParams.onCancel();
    }
    $state.go($stateParams.cancel || '^');
  };
  $scope.picked = function (customer) {
    return customer.selected || customer.create;
  };
  $scope.alreadyAssigned = function (customer, existing) {
    // good luck figuring out what this means
    if (customer.selected && !customer.create && (!existing.accounting || customer.selected.id != existing.accounting.id)) {
      if (customer.selected.client) return `client '${customer.selected.client.name}'`;
      if (customer.selected.matter) return `${$scope.me.terms.matter} '${customer.selected.matter.name}'`;
    }
    return false;
  };
  $scope.clientChange = function (select) {
    if (select) {
      $scope.data.clientCustomer.create = !$scope.data.clientCustomer.selected;
    }
    // Creating a new client obviously means the matter needs a new customer too, since
    // there's no existing client to search sub-customers under. This used to also default to
    // "create" whenever the selected client's preloaded .clients was empty, but sc-46822
    // stopped preloading sub-customers, so that signal no longer exists -- the matter-level
    // search (searchClient('matter')) now decides create-vs-select on its own instead.
    if ($scope.data.clientCustomer.create) {
      $scope.data.matterCustomer.create = true;
      $scope.data.matterCustomer.name = $scope.data.matter.label;
    }
  };
  $scope.matterChange = function (select) {
    $scope.data.matterCustomer.create = $scope.data.matterCustomer.selected;
  };
  $scope.setMatterCreateName = function () {
    $scope.data.matterCustomer.name = $scope.data.matter.label;
  };
  activate();

  ///////////////////

  function activate() {
    if (!$stateParams.id && !$stateParams.matterId && !$stateParams.clientId) {
      throw "Requires id, matter Id or clientId";
    }
    userService.me().then(me => {
      $scope.me = me;
      let getClientOrMatter;
      if ($stateParams.matterId || $state.current.name.indexOf('matter') == 0) {
        getClientOrMatter = leanLawApi.getMatter({
          id: $stateParams.matterId || $stateParams.id
        }).then(matter => {
          $scope.data.matter = matter;
          setClientBilling(matter.client);
          return loadAccountingNames(matter);
        });
      } else {
        getClientOrMatter = leanLawApi.getClient({
          id: $stateParams.clientId || $stateParams.id
        }).then(client => {
          $scope.data.matter = {
            client
          };
          setClientBilling(client);
          return loadAccountingNames($scope.data.matter);
        });
      }
      accountingService.verify(true).then(() => {
        getClientOrMatter.then(() => {
          $scope.loading = false;
        }).catch(err => {
          // Covers a non-404 getClientById failure (see below) and any searchClients
          // failure inside findByName -- without this, either left the promise chain
          // unhandled and the spinner never cleared.
          alerts.error(err);
          $scope.cancel();
        });
      }).catch(() => {
        $scope.cancel();
      });
    });
  }
  function setClientBilling(client) {
    const settings = $scope.me.company.settings.clientBilling || {};
    // $scope.data.allowChange = settings.allowChange;
    $scope.data.billClient = client.billing && typeof client.billing.billClient !== 'undefined' ? client.billing.billClient : settings.billClient;
    loadedBillClient = $scope.data.billClient;
    $scope.data.pickClientBilling = !client.accounting && settings.allowChange;
  }

  // Resolve a single already-known QuickBooks id -- bounded, no scan. Only a genuine 404
  // means "not found" (id no longer exists in QuickBooks); any other failure (network,
  // 5xx, timeout) is re-thrown rather than defaulting to a name search, since a still-valid
  // link falling through to "create new" on a transient error would orphan the existing
  // QuickBooks customer on save.
  function getClientById(id) {
    return accountingService.getClient(id).catch(err => {
      if (err && err.status === 404) return null;
      throw err;
    });
  }

  // Bounded name search (sc-46822) -- used only when there's no already-known id to resolve,
  // i.e. exactly the "matter missing in QuickBooks" case this story targets. Matches on the
  // same name-or-label comparison the old whole-firm scan used, just against a handful of
  // search results instead of every customer in the realm.
  function findByName(term, parentId, matchesFn) {
    if (!term) return $q.resolve(null);
    return accountingService.searchClients(term, parentId).then(results => _.find(results, matchesFn) || null);
  }
  function loadAccountingNames(matter) {
    // There are some ins and outs here because the quickbooks accounts assigned to the matter
    // (or client) might be gone in quickbooks -- id lookup falls back to a name search rather
    // than assuming "not found" means "create new".
    const clientLookup = (matter.client.accounting ? getClientById(matter.client.accounting.id) : $q.resolve(null)).then(match => match || findByName(matter.client.label, null, c => strip(c.name) == strip(matter.client.name) || strip(c.name) == strip(matter.client.label)));
    return clientLookup.then(clientMatch => {
      if (clientMatch) {
        $scope.data.clientCustomer.selected = clientMatch;
        $scope.data.clientCustomer.results = [clientMatch];
      } else {
        $scope.data.clientCustomer.create = true;
        $scope.data.clientCustomer.name = matter.client.label;
      }
      if (!$scope.data.matter.id) {
        return null;
      }
      const parentId = clientMatch && clientMatch.id;
      const matterLookup = (matter.accounting ? getClientById(matter.accounting.id) : $q.resolve(null)).then(match => match || (parentId ? findByName(matter.label, parentId, c => strip(c.name) == strip(matter.name) || strip(c.name) == strip(matter.label)) : null));
      return matterLookup.then(matterMatch => {
        if (matterMatch) {
          $scope.data.matterCustomer.selected = matterMatch;
          $scope.data.matterCustomer.results = [matterMatch];
        } else {
          $scope.data.matterCustomer.create = true;
          $scope.data.matterCustomer.name = matter.label;
        }
      });
    });
  }
  function strip(s) {
    return s.replace(/\W+/g, '').toLowerCase();
  }
  $scope.next = function () {
    $scope.data.pickClientBilling = false;
  };
  $scope.changeClientBilling = function (billClient) {
    $scope.data.billClient = billClient;
  };
  $scope.save = function () {
    $scope.error = null;

    // Guarded at Save, not on the mode buttons: those would offer a settlement
    // reset for a change the user can still cancel out of.
    if (!accountingModeChanged()) return confirmReassignThenSave();

    // Save is ng-disabled on this; without it a second click starts a second guard.
    $scope.saving = true;
    return accountingModeGuard.check(accountingModeContext()).then(allowed => {
      // Inside the callback: $applyAsync defers a digest, Angular runs the entry
      // even if $destroy landed in between, and Cancel is live during the lookup.
      $scope.$applyAsync(() => {
        if (destroyed) return;
        $scope.saving = false;
        if (allowed) confirmReassignThenSave();
      });
    }).catch(err => {
      // Never hand the raw rejection to the template — see billClientChangeErrorMessage.
      $scope.$applyAsync(() => {
        if (destroyed) return;
        $scope.saving = false;
        $scope.error = billClientChangeErrorMessage(err);
      });
    });
  };

  // Coerced both sides: the form treats any falsy value as Matter level, and this
  // matches billClientChangeDecision's own effective-equality test.
  function accountingModeChanged() {
    return !!$scope.data.billClient !== !!loadedBillClient;
  }
  function clientAccountingEnabled() {
    return !!($scope.me && $scope.me.features && $scope.me.features.settlementClientAccounting);
  }
  function accountingModeContext() {
    const features = $scope.me && $scope.me.features || {};
    return {
      value: !!$scope.data.billClient,
      billClientValue: !!loadedBillClient,
      // The client, not the matter (sc-47289). This is what closes the gap the
      // matter-scoped version left here: the client-level entry to this modal has
      // no matter id, so it used to skip the settlement check entirely and change
      // the mode unguarded. The client is present on both entries, and the setting
      // was always client-level anyway.
      clientId: $scope.data.matter.client && $scope.data.matter.client.id,
      settlementEnabled: !!features.settlementTab,
      clientAccountingEnabled: clientAccountingEnabled(),
      matterTerm: $scope.me && $scope.me.terms && $scope.me.terms.Matter || 'Matter'
    };
  }
  function confirmReassignThenSave() {
    const {
      matter
    } = $scope.data;
    if (reassiging(matter.accounting, $scope.data.matterCustomer) || reassiging(matter.client.accounting, $scope.data.clientCustomer)) {
      return bootbox.confirm("<h3>Change QuickBooks assigned customer?</h3><p>This client was assigned to a customer in QuickBooks. Changing the assignment can have accounting consequences if you have created invoices already or have trust accounting set up.", result => {
        if (result) reallySave();
      });
    }
    reallySave();
  }
  function reassiging(accounting, customer) {
    if (!accounting) return false;
    if (customer.create || !customer.selected) return true;
    return accounting.id != customer.selected.id;
  }
  function reallySave() {
    let api;
    if ($scope.data.billClient || !$scope.data.matter.id) {
      var update = {
        accounting: formToAccounting($scope.data.clientCustomer),
        billClient: $scope.data.billClient
      };
      api = leanLawApi.updateClientAccounting({
        id: $scope.data.matter.client.id,
        body: update
      });
    } else {
      var update = {
        accounting: formToAccounting($scope.data.matterCustomer),
        client: {
          accounting: formToAccounting($scope.data.clientCustomer)
        }
      };
      api = leanLawApi.updateMatterAccounting({
        id: $scope.data.matter.id,
        body: update
      });
    }
    $scope.saving = true;
    api.then(updated => {
      // Lazy invalidate (sc-46822), not accountingService.refresh() -- refresh() clears AND
      // immediately re-fetches the whole-firm client list, which used to re-run the realm
      // scan on every save. clearCache() just invalidates it; the next consumer that actually
      // needs the list (trust dialog, matter view) pays for one fetch on demand instead.
      accountingService.clearCache();
      $state.go('^', $stateParams, {
        reload: true
      });
    }).catch(err => {
      // Ungated, and ordered first on purpose: this was `err.body.message`, which
      // threw whenever the rejection had no body — and threw before saving was
      // reset, leaving Save disabled for good. Restoring that deref off-flag would
      // put a crash back, so only the copy below rides the flipper.
      $scope.saving = false;
      // Curated copy is part of the accounting-mode work, so it waits for the flag.
      // Off-flag keeps the backend message it already showed — pre-existing
      // security.md §3 debt, grandfathered until the flipper rolls out.
      $scope.error = clientAccountingEnabled() ? saveErrorMessage(err) : err && err.body && err.body.message || saveErrorMessage(err);
    });
  }
  function saveErrorMessage(err) {
    const status = err && err.status;
    if (status === 403) {
      return "You don't have permission to change this QuickBooks connection.";
    }
    if (typeof status === 'number' && status >= 500) {
      return 'Something went wrong on our end, so nothing was saved. Please try again.';
    }
    return "We couldn't save this QuickBooks connection. Please try again.";
  }
  function formToAccounting(form) {
    if (form.create) {
      return {
        name: form.name
      };
    }
    if (form.selected) {
      return {
        id: form.selected.id,
        name: form.selected.name
      };
    }
    return null;
  }
}]);